
const lazyLoad = view => () => import(`@/components/modules/mdm/${view}`);

const mdm = [
  {
    path: '/mdm/roles',
    name: 'Role',
    component: lazyLoad('role'),
    meta: {
      title: 'Roles',
      requiresAuth: true,
    },
  },
  // {
  //   path: '/mdm/materialcategories',
  //   name: 'materialcategory',
  //   component: lazyLoad('material-category'),
  //   meta: {
  //     title: 'Material Categories',
  //   },
  // },
  {
    path: '/mdm/dedicatedtrucks',
    name: 'dedicatedtruck',
    component: lazyLoad('dedicated-truck'),
    meta: {
      title: 'Dedicated Trucks',
    },
  },
  {
    path: '/mdm/vendor-depots',
    name: 'VendorDepots',
    component: lazyLoad('vendor-depot'),
    meta: {
      title: 'Vendor Depots',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/vendor-depot/:depotId',
    name: 'VendorDepotDetails',
    component: lazyLoad('depot/show'),
    meta: {
      title: 'Vendor Depots',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/locations',
    name: 'mdmLocation',
    component: lazyLoad('location'),
    meta: {
      title: 'Location',
      requiresAuth: true,
    },
  },
  // {
  //   path: '/mdm/transit-management',
  //   name: 'transit_management',
  //   component: lazyLoad('transit'),
  //   meta: {
  //     title: 'Transit Management',
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/mdm/loading',
    name: 'loading',
    component: lazyLoad('loading'),
    meta: {
      title: 'Loading/Unloading',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/rejection',
    name: 'exceptions',
    component: lazyLoad('exceptions'),
    meta: {
      title: 'Rejections',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/extra-drop-off-charge',
    name: 'extra_drop_off_charge',
    component: lazyLoad('extra-drop-off-charges'),
    meta: {
      title: 'Drop Off Charges',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/dedicated-truck-history/:dedicated_truck_id',
    name: 'dedicated_truck_history',
    component: lazyLoad('dedicated-truck/history'),
    meta: {
      title: 'Dedicated Truck History',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/blacklist-driver',
    name: 'blacklist_driver',
    component: lazyLoad('blacklist-drivers'),
    meta: {
      title: 'Driver Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/blacklist-vehicle',
    name: 'blacklist_vehicle',
    component: lazyLoad('blacklist-vehicles'),
    meta: {
      title: 'Vehicle Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/blacklist-driver/:id',
    name: 'blacklist_driver_details',
    component: lazyLoad('blacklist-drivers/details'),
    meta: {
      title: 'Driver Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/blacklist-vehicle/:id',
    name: 'blacklist_vehicle_details',
    component: lazyLoad('blacklist-vehicles/details'),
    meta: {
      title: 'Vehicle Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/blacklist-driver/:id',
    name: 'blacklist_driver_details',
    component: lazyLoad('blacklist-drivers/details'),
    meta: {
      title: 'Driver Details',
      requiresAuth: true,
    },
  },
  {
    path: '/mdm/purchase-order/:id',
    name: 'PurchaseOrderDetails',
    component: lazyLoad('purchase-order/show'),
    meta: {
      title: 'Purchase Order',
      requiresAuth: true,
    },
  },
];

export default mdm;
